export default "__VITE_ASSET__DWONE_aa__"